import { render, staticRenderFns } from "./StandardManage.vue?vue&type=template&id=b7bb293e&scoped=true"
import script from "./StandardManage.vue?vue&type=script&lang=js"
export * from "./StandardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bb293e",
  null
  
)

export default component.exports